import Arrow from "../../assets/images/Doodles/arrow_right.svg"
import { useTranslation } from "react-i18next";
import {ReactComponent as LocationPin} from "../../assets/images/Icons/location-pin.svg"
import {ReactComponent as Calendar} from "../../assets//images/Icons/calendar.svg"

function ActivityItem({title, location, recolected, date, description, image, url}) {
  const { t } = useTranslation(['common']);

  return (
    <div className="flex min-w-[300px] max-w-[600px] min-h-[300px] max-h-[500px] gap-4">
      {/* Línea vertical decorativa */}
      <div className="w-1 h-full bg-bluekali-white rounded-full flex-shrink-0"/>
      
      {/* Contenido principal */}
      <div className="flex flex-col justify-between flex-1 min-h-0 h-full w-full">
        {/* Texto */}
        <div className="flex-1 overflow-hidden">
          <h2 className="font-black text-xl line-clamp-2">
            {title}
          </h2>

          <div className="flex items-center justify-start">
            <Calendar className="text-bluekali-tomato mr-1 w-4"/>
            <p className="text-xs font-medium text-bluekali-white/85 ">
                {date}
            </p>
          </div>

          <div className="flex items-center justify-start">
            <LocationPin className="text-bluekali-tomato mr-1 w-4"/>
            <p className="text-xs font-medium text-bluekali-white/85 ">
                {location}
            </p>
          </div>

          {recolected && 
          <div className="flex items-center justify-start">
            {/* <LocationPin className="text-bluekali-tomato mr-1 w-4"/> */}
            <p className="text-2xl font-medium text-bluekali-white mt-2">
                {recolected}
                <span className="text-xs text-bluekali-white/85">
                  {t('impact.kg_recolected')}
                </span>
            </p>
          </div>
          }

          <p className="text-xs text-bluekali-white/70 w-11/12 mb-4">
            {description}
          </p>
        </div>
        
        {/* Imagen */}
        {image && (
          <img 
            alt={title || "Activity image"} 
            className="w-full min-h-20 max-h-40 rounded-xl object-cover mb-3" 
            src={image}
          />
        )}
        
        {/* Link "See more" */}
        {url && (
          <a 
            href={url} 
            target="_blank" 
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-1 self-start"
          >
            <p className="text-xs font-bold text-bluekali-white hover:text-white transition-colors">
              {t('impact.see_more')}
            </p>
            <img 
              src={Arrow} 
              alt="" 
              className="w-3 h-3 -rotate-45 group-hover:translate-x-0.5 transition-transform"
            />
          </a>
        )}
      </div>
    </div>
  )
}

export default ActivityItem